// Service page content for Skilled Nominated (Subclass 190).
// Sourced from docs/research/australian-visa-pathways.md §1.
// COMPLIANCE: we are not a registered migration agent and do not give migration
// advice or assess eligibility; the regulated advice and lodgement are a
// registered migration agent's. No guaranteed outcomes; honest about nomination
// dependence; no unverified dollar figures stated as fact. "Who does what"
// disclosure and disclaimer are rendered by the shared page template.

const skilledNominated190 = {
  groupSlug: "skilled-migration",
  slug: "skilled-nominated-190",
  title: "Skilled Nominated visa (Subclass 190)",
  eyebrow: "Skilled Migration",
  intro:
    "The Subclass 190 is a points-tested permanent visa for skilled workers nominated by an Australian state or territory. The nomination adds 5 points to your score, which can make an invitation more achievable, in return for a commitment to live in that state. If granted, you receive permanent residence.",

  chips: [
    { label: "Visa type", value: "Permanent residence" },
    { label: "Nomination", value: "State or territory (+5 points)" },
    { label: "Points-tested", value: "Yes, by invitation" },
    { label: "Apply via", value: "SkillSelect (EOI)" },
  ],

  whoFor: [
    "Skilled workers whose occupation is on a state or territory nomination list.",
    "Applicants who want permanent residence and are willing to commit to living in the nominating state.",
    "People whose points are stronger with the 5-point nomination boost than on the independent 189.",
  ],

  essentials: [
    {
      title: "A state or territory nomination",
      detail:
        "You must be nominated by a participating state or territory. Each runs its own occupation lists, criteria, and allocation, which often exceed the federal minimum.",
    },
    {
      title: "A positive skills assessment",
      detail:
        "Your nominated occupation must be assessed by the relevant assessing authority and appear on the applicable list for the 190.",
    },
    {
      title: "An invitation through SkillSelect",
      detail:
        "You submit an Expression of Interest, and the nominating state invites you to apply. You cannot apply directly.",
    },
    {
      title: "Under 45 and at least competent English",
      detail:
        "The same age and English thresholds as other skilled visas apply, and both feed your points score.",
    },
    {
      title: "Meet the points pass mark (nomination adds 5)",
      detail:
        "The state nomination adds 5 points. You still need to be competitive for that state's occupation and round.",
    },
    {
      title: "A genuine commitment to the state",
      detail:
        "States nominate people who intend to live and work in their jurisdiction, and some ask you to confirm this.",
    },
  ],

  process: [
    {
      title: "Skills assessment",
      detail:
        "A registered migration agent confirms your occupation, and we organise and prepare the evidence to obtain a positive assessment from the right assessing authority.",
    },
    {
      title: "Match you to a state",
      detail:
        "A registered migration agent identifies which states nominate your occupation and which criteria you meet, so you target the right one. We gather what each state asks for.",
    },
    {
      title: "Prepare your EOI and state application",
      detail:
        "We build your SkillSelect EOI and state nomination file to a lodgement standard. A registered migration agent finalises the points claim and lodges.",
    },
    {
      title: "Receive nomination and invitation",
      detail:
        "If the state nominates you, you are invited to apply for the visa within the time allowed.",
    },
    {
      title: "Lodge the visa application",
      detail:
        "We prepare a thorough, well-documented file. A registered migration agent lodges the application and deals with the Department.",
    },
    {
      title: "Decision",
      detail:
        "The Department decides. If granted, the 190 is permanent residence from the start.",
    },
  ],

  faqs: [
    {
      q: "What does the state nomination give me?",
      a: "It adds 5 points to your score and is required for the 190. In exchange, you commit to living and working in the nominating state, at least initially. Each state sets its own occupation lists and criteria, which can be stricter than the federal minimum.",
    },
    {
      q: "Do I have to stay in that state forever?",
      a: "The 190 is a permanent visa with no formal regional condition attached to the grant, but you nominate on the basis of intending to live in that state, and you should genuinely plan to. A registered migration agent explains each state's expectations before you apply.",
    },
    {
      q: "Is the 190 easier to get than the 189?",
      a: "Not easier, but different. The 5-point boost and a state's specific demand for your occupation can make an invitation more achievable than the open, highly competitive 189. A registered migration agent assesses both for you and recommends the stronger path.",
    },
    {
      q: "Which states can nominate me?",
      a: "It depends on your occupation, your points, and each state's current priorities, which change through the year. A registered migration agent checks the live state lists for your occupation rather than relying on last season's settings.",
    },
  ],

  related: [
    "skilled-independent-189",
    "skilled-regional-491",
    "skills-assessment",
  ],

  lastVerified: "13 July 2026",
};

export default skilledNominated190;
